<template>
    <div>
        <v-subheader v-if="assignments.length == 0" class="my-2"><i>No assignments</i></v-subheader>
        <div class="mt-5" v-else></div>
        <lesson-assignment
          v-for="assignment in assignments"
          :key="assignment.id"
          :name="assignment.name"
          :count="assignment.count"
          :color="assignment.color"
          class="mb-4 mt-0 mx-8"
        />
        <div class="mt-7" v-if="assignments.length > 0"></div>
    </div>
</template>

<script>

import LessonAssignment from './LessonAssignment.vue'

export default {
    name: 'LessonAssignmentList',
    components: {
        LessonAssignment
    },
    props: {
        student_id: Number
    },
    computed: {
        assignments () {
            var student = this.$store.getters['trainer/students'].find(s => s.id == this.student_id);
            return student.assignments;
        }
    }
};
</script>
